// src/Components/FloatingIcon/ChatFloat.jsx

import React, { useState, useEffect } from "react";
import styles from "./ChatFloat.module.css";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import ChatBox from "./ChatBox";
import LeadFormBox from "./LeadFormBox";
import { useLeadForm } from "./useLeadForm";

const ChatFloat = () => {
  const [open, setOpen] = useState(false);
  const [activeModule, setActiveModule] = useState("chat"); // "chat" or "form"
  const [formCallback, setFormCallback] = useState(null);
  const [formState, setFormState] = useState(null);
  const [formType, setFormType] = useState(null);
  const { registerFormTrigger } = useLeadForm();

  useEffect(() => {
    // Register trigger globally
    registerFormTrigger((state, type, callback) => {
      setFormState(state);
      setFormType(type);
      setFormCallback(() => callback); // store callback
      setActiveModule("form");
      setOpen(true);
    });
  }, []);

  const close = () => {
    setOpen(false);
    setActiveModule("chat");
    setFormCallback(null);
  };

  return (
    <>
      <div
        className={styles.floatingIcon}
        onClick={() => {
          setActiveModule("chat");
          setOpen(!open);
        }}
      >
        <EmojiObjectsIcon fontSize="large" />
      </div>

      {open && activeModule === "chat" && <ChatBox onClose={close} />}
      {open && activeModule === "form" && (
        <LeadFormBox
          formType={formType}
          planData={formState}
          onClose={close}
          onSubmit={(formData) => {
            if (formCallback) formCallback(formData, formState, formType);
          }}
        />
      )}
    </>
  );
};

export default ChatFloat;
